export default __webpack_public_path__ + "static/media/bg_wide.be381f2b.png";